import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import dictionary from '../../../dictionary'
import SelectIcon from '../Icons/SelectIcon'
import isDarkColor from '../../../utils/is-dark-color'
import LegendsTooltip from './LegendsTooltip'
import styles from './color.module.scss'
import styled from 'styled-components'

function Color(props) {
  const { content, current, onChange, name, compact } = props
  return (
    <div className={classNames(styles.root, compact && styles.rootCompact)}>
      <Label>Цвета</Label>
      <div className={styles.content}>
        {content.map(({ label, value, disabled }) => (
          <span key={value} className={styles.buttonContainer}>
            <LegendsTooltip title={disabled ? `` : dictionary.item[value]}>
              <button
                disabled={disabled}
                className={
                  current === value && isDarkColor(label)
                    ? classNames(styles.item, styles.itemInverted)
                    : styles.item
                }
                style={{
                  backgroundColor: label,
                  borderColor: label === `#fbfbfb` ? `#c9cbcc` : `transparent`,
                }}
                onClick={() => onChange(name, value)}
              >
                {current === value && <SelectIcon />}
              </button>
            </LegendsTooltip>
          </span>
        ))}
      </div>
    </div>
  )
}

const Label = styled.div`
  font-size: 16px;
  margin-top: 24px;
  margin-bottom: 16px;
`

Color.propTypes = {
  name: PropTypes.string,
  compact: PropTypes.bool,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func,
}

export default Color
